/**
 * Last-write-wins create that respects optimistic local state.
 *
 * If no entity with this uuid exists locally, install the input.
 *
 * If an entity already exists, compare ms-precision `updated_at`s:
 * - existing is older or equal to input → keep existing, drop input.
 * - existing is newer than input → overwrite with input (server reply
 *   reverting an optimistic local mutation).
 *
 * Tie-break for same-ms (`existing.updated_at === input.updated_at`):
 * the existing entity is preserved and the incoming is silently
 * dropped. JS Date.now() resolution is ~1ms; in practice human and
 * network latency dominate, so collisions are rare. If two mutations
 * are produced inside the same millisecond they are indistinguishable
 * and the second one is no-op'd here.
 *
 * @param {String} type
 * @param {Object} scenario
 * @param {Object} input
 */
export default function create(type, scenario, input) {
  if (!Object.hasOwn(scenario.entities[type], input.uuid)) {
    scenario.entities[type][input.uuid] = input;
    return;
  }

  const existing = scenario.entities[type][input.uuid];
  if (existing.updated_at <= input.updated_at) {
    return;
  }

  scenario.entities[type][input.uuid] = input;
}
